import { queryOptions, type QueryClient } from "@tanstack/react-query";
import { api, unwrap } from "./api";

function isUnauthorized(error: unknown) {
  if (!error || typeof error !== "object") return false;
  const status = "status" in error ? Number(error.status) : undefined;
  return status === 401;
}

export const meQueryOptions = queryOptions({
  queryKey: ["me"],
  queryFn: async () => unwrap(await api.auth.me.get()),
  retry: (count, error) => !isUnauthorized(error) && count < 2,
  staleTime: 5 * 60 * 1000,
});

export type Me = Awaited<ReturnType<NonNullable<typeof meQueryOptions.queryFn>>>;

/** Cached session if present; otherwise GET /auth/me. */
export function loadSession(queryClient: QueryClient) {
  return queryClient.ensureQueryData(meQueryOptions);
}
